export const appPalette = {
    primary: "#2563eb",
    primaryDark: "#1d4ed8",
    primarySoft: "#eff6ff",
    secondary: "#0f8b8d",
    secondaryDark: "#0b7072",
    secondarySoft: "#ccfbf1",
    success: "#16a34a",
    successDark: "#15803d",
    successSoft: "#dcfce7",
    warning: "#d97706",
    warningDark: "#b45309",
    warningSoft: "#fef3c7",
    error: "#dc2626",
    errorDark: "#b91c1c",
    errorSoft: "#fee2e2",
    info: "#0284c7",
    infoDark: "#0369a1",
    infoSoft: "#e0f2fe",
    mob: "#ffcc00",
    navy: "#0d0f1b",
    navyBlue: "#203262",
    surface: "#ffffff",
    surfaceMuted: "#f8fafc",
    border: "#e2e8f0",
    text: "#1f2937",
    textMuted: "#64748b",
} as const;
